const mutations = {
  SET_ALL(state, payload){
    let invoices = payload.filter(i => i.show_kv);
    state.all = invoices;
  }
};

export default mutations;